import { render, staticRenderFns } from "./ManageProducerMail.vue?vue&type=template&id=bd038666"
import script from "./ManageProducerMail.vue?vue&type=script&lang=js"
export * from "./ManageProducerMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports